import React from 'react'



function videoFront(){
    return(
        <div class="videoBack">
                <video  className="bgVideo" autoPlay playsInline muted loop>
                        <source src="https://compilelabs.s3.ca-central-1.amazonaws.com/videos/Compile+Labs+Front.mp4" type="video/mp4" />
                </video>
        </div>
    )
}

export default videoFront;